var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11494 0.996553C2.56075 0.380788 1.61232 0.33087 0.996553 0.885059C0.380788 1.43925 0.33087 2.38768 0.885059 3.00345L3.11494 0.996553ZM11 12L9.88506 13.0034C10.1648 13.3143 10.5616 13.4942 10.9798 13.4999C11.3979 13.5055 11.7995 13.3363 12.0875 13.0331L11 12ZM21.5875 3.03312C22.1581 2.43251 22.1337 1.48308 21.5331 0.912501C20.9325 0.341922 19.9831 0.366267 19.4125 0.966876L21.5875 3.03312ZM0.885059 3.00345L9.88506 13.0034L12.1149 10.9966L3.11494 0.996553L0.885059 3.00345ZM12.0875 13.0331L21.5875 3.03312L19.4125 0.966876L9.9125 10.9669L12.0875 13.0331Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.5ab0f0ea252599a076b314e81baf4aab.svg";
export { ForwardRef as ReactComponent };